import { Component } from '@angular/core';
import { EntityCheckboxListComponent } from '../../../../shared/checkbox-list/components/entity-checkbox-list.component';
import { ParcHyperviseur } from '../entities/parc-hyperviseur.entity';

@Component({
	selector: 'parc-hyperviseur-checkbox-list',
	templateUrl: '../../../../shared/checkbox-list/components/entity-checkbox-list.html',
	styleUrls: ['../../../../shared/checkbox-list/components/entity-checkbox-list.css']
})
export class ParcHyperviseurCheckboxListComponent extends EntityCheckboxListComponent<ParcHyperviseur> {
	override label = "Hyperviseur:";

	override getEntityLabel = (hyperviseur: ParcHyperviseur) => hyperviseur.label;

	override entities = ParcHyperviseur.ALL;

	constructor() {
		super();
	}
}